module.exports = __webpack_public_path__ + "static/media/thoracic-surgery-icon@3x.0b1fbc61.png";